import React from 'react';

import i18n from '@client/utils/i18n';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

const SectionTimelineInfo = () => (
    <Grid item xs={12} sx={{ textAlign: 'center' }}>
        <Typography variant="subtitle2" align="center">
            {i18n('section_timeline_info')}
        </Typography>
    </Grid>
);

export default React.memo(SectionTimelineInfo);
